import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    className as _$cn,
    superCall as _$su,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createTextVNode as _$ct,
} from 'intact';
import {linkEvent} from 'intact';
import {DropdownMenu} from '../dropdown';
import {DatepickerCalendar} from './calendar';
import {DatepickerTime} from './time';
import {Icon} from '../icon';
import {Button} from '../button';
import {_$} from '../../i18n';
import {makeStyles, makePanelStyles, makeHighlightStyles} from './styles';
import {PanelFlags} from './usePanel';
import {isFunction} from 'intact-shared';
import {Tabs, Tab} from '../tabs';
import {Position} from './useHighlight';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const { k } = this.config;
    const {className, type, range, multiple, shortcuts, size} = this.get();
    const {
        value: {value},
        onChangeDate,
        /* onConfirm, */
        onChangeTime,
        onChangeDateForRange,
        getTimeValue,
    } = this.value;
    const { onConfirm } = this.confirm;
    const { position, handleInputClick, highlightWidth, highlightLeft } = this.highlight;
    // 判断是否显示双面板
    const showDualPanels = range && type !== 'datetime';
    
    const classNameObj = {
        [`${k}-datepicker-content`]: true,
        [className]: className,
        [makePanelStyles(k)]: true,
    };
    const classDatePickerObj = {
        [`${k}-datepicker`]: true,
        [makeHighlightStyles(k, size, highlightWidth.value, highlightLeft.value)]: range,
        [makeStyles(k)]: true,
    }
    const {isDisabledTime, isDisabledConfirm} = this.disabled;
    const {startRef, endRef} = this.panel;
    const generatePanel = (flag) => {
        return (
            _$ce(2, 'div', [
                _$cc(DatepickerCalendar, {
                    'value': value,
                    'ev-change': onChangeDate,
                    'type': type === 'datetime' ? 'date' : type,
                    'flag': flag,
                    'ref': flag === PanelFlags.Start ? startRef : endRef,
                    'highlightPosition': position.value
                }, null, flag === PanelFlags.Start ? startRef : endRef),
                (type === 'datetime') ?
                    _$ce(2, 'div', (() => {
                        let timeValue = getTimeValue(flag);
                        if (flag === PanelFlags.End && !timeValue) {
                            timeValue = getTimeValue(PanelFlags.Start);
                        }
                        let timeString = '00:00:00';
                    
                        if (timeValue) {
                            const valueString = this.formats.getShowString(timeValue).split(/\s+/);
                            timeString = valueString[1];
                        }
                    
                        return [
                            _$ce(2, 'div', timeString, 0, _$cn(`${k}-datepicker-time-time`)),
                            _$cc(DatepickerTime, {
                                'value': timeValue,
                                'ev-$change:value': v => onChangeTime(v, flag),
                                'format': this.formats.getValueFormat(),
                                'flag': flag,
                                'isDisabledTime': isDisabledTime
                            })
                        ]
                    })(), 0, _$cn(`${k}-datepicker-time-wrapper`)) :
                    undefined
            ], 0, _$cn(`${k}-datepicker-calendar-time-wrapper`))
        );
    };
    
    return _$su.call($this, {
        'className': _$cn(classDatePickerObj),
        'onClick': handleInputClick,
        'alwaysShowOnClick': true
    }, function($blocks) {
        var _$blocks = {}, __$blocks = _$ex({}, $blocks);
        return (
            (
                (_$blocks['base-menu'] = function($super) {
                    return (
                        _$cc(DropdownMenu, {
                            'className': _$cn(classNameObj),
                            'children': [
                                (shortcuts && shortcuts.length) ?
                                    _$ce(2, 'div', shortcuts.map($value => {
                                        const label = isFunction($value.label) ? $value.label() : $value.label;
                                        return _$ce(2, 'div', label, 0, _$cn(`${k}-datepicker-shortcut c-ellipsis`), {
                                            'title': label,
                                            'ev-click': linkEvent($value, this.setByShortcut)
                                        })
                                    }), 0, _$cn(`${k}-datepicker-shortcuts`)) :
                                    undefined,
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', [
                                        generatePanel(!showDualPanels && position.value === Position.End ? PanelFlags.End : PanelFlags.Start),
                                        _$ct('\n                    '),
                                        showDualPanels ? generatePanel(PanelFlags.End) :  null
                                    ], 0, _$cn(`${k}-datepicker-calendars`)),
                                    (type === 'datetime') ?
                                        _$ce(2, 'div', (
                                            _$cc(Button, {
                                                'type': 'primary',
                                                'size': 'small',
                                                'disabled': isDisabledConfirm(),
                                                'ev-click': onConfirm,
                                                'children': _$('确定')
                                            })
                                        ), 2, _$cn(`${k}-datepicker-footer`)) :
                                        undefined
                                ], 0, _$cn(`${k}-datepicker-wrapper`))
                            ]
                        })
                    );
                }),
                (__$blocks['base-menu'] = function($super, data) {
                    var block = $blocks['base-menu'];
                    var callBlock = function() {
                        return _$blocks['base-menu'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                })
            ),
            (
                (_$blocks['suffix'] = function($super) {
                    return (
                        _$cc(Icon, {
                            'className': _$cn(`${k}-icon-calendar`)
                        })
                    );
                }),
                (__$blocks['suffix'] = function($super, data) {
                    var block = $blocks['suffix'];
                    var callBlock = function() {
                        return _$blocks['suffix'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                })
            ),
            __$blocks
        );
    }.call($this, $blocks), $__proto__);
};